module.exports = __webpack_public_path__ + "static/DomApotheke-6eb50d7cbb9fff0ee3b102008ae15fcb.jpg";